/**
 * @file UserRoleBadge.tsx
 * @brief Visual badge mapping `users.role` → color/variant.
 *
 * @author DES
 * @date 26-05-2026
 */

import { ShieldCheck, User } from "lucide-react";
import { CompanyAdmin } from "@/components/icons/CompanyAdmin";
import { Badge } from "@/components/ui/Badge";
import type { UserRole } from "@/shared/types/api";

export function UserRoleBadge({ role }: { role: UserRole }) {
  switch (role) {
    case "superadmin":
      return (
        <Badge variant="primary" className="gap-1">
          <ShieldCheck className="h-3 w-3" />
          Super Admin
        </Badge>
      );
    case "admin":
      return (
        <Badge variant="default" className="gap-1">
          {/* DES 08-10-2026: app icon, was Building2 */}
          <CompanyAdmin className="h-3 w-3" />
          Company Admin
        </Badge>
      );
    case "user":
      return (
        <Badge variant="muted" className="gap-1">
          <User className="h-3 w-3" />
          User
        </Badge>
      );
    default:
      return <Badge variant="outline">{String(role)}</Badge>;
  }
}
